import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "@tanstack/react-router";
import { portalRouter } from "components/Navigation/portalRouter";
import { useVersionChecker } from "utils/useVersionChecker/useVersionChecker";

/** Main component for Patient Portal. Provides universal functionality and routing. */
export const App = () => {
    useVersionChecker();

    return (
        <>
            <RouterProvider router={portalRouter} />
            <ReactQueryDevtools initialIsOpen={false} />
        </>
    );
};
